export const NAMES = [
  // Roman mythical and historical figures
  'AI Marcus', 'AI Livia', 'AI Augustus', 'AI Minerva', 'AI Julius', 'AI Diana', 'AI Maximus', 'AI Victoria', 'AI Aurelius', 'AI Juno',
  'AI Cassius', 'AI Ceres', 'AI Octavius', 'AI Venus', 'AI Lucius', 'AI Vesta', 'AI Titus', 'AI Fortuna', 'AI Scipio', 'AI Cybele',
  
  // Ancient Greek mythical and historical figures  
  'AI Zeus', 'AI Athena', 'AI Apollo', 'AI Artemis', 'AI Hermes', 'AI Hera', 'AI Ares', 'AI Aphrodite', 'AI Hades', 'AI Demeter',
  'AI Perseus', 'AI Andromeda', 'AI Theseus', 'AI Cassandra', 'AI Achilles', 'AI Helena', 'AI Odysseus', 'AI Penelope', 'AI Hector', 'AI Iphigenia',
  
  // Ancient Chinese mythical and historical figures
  'AI Fuxi', 'AI Nuwa', 'AI Huangdi', 'AI Leizu', 'AI Yao', 'AI Ehuang', 'AI Shun', 'AI Nvying', 'AI Yu', 'AI Jiandi',
  'AI Tang', 'AI Daji', 'AI Wen', 'AI Diaochan', 'AI Wu', 'AI Mulan', 'AI Confucius', 'AI Laozi', 'AI Mencius', 'AI Zhuangzi'
];

export const getRandomName = () => {
  const randomIndex = Math.floor(Math.random() * NAMES.length);
  return NAMES[randomIndex];
};